import React from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';
import CustomerBase from './CustomerBase';
const Dashboard = () => {
  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className=" flex-1" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
        <Header title="Tenant Management" dropdown={2} />

        <Card className="flex-1" bgColor="rgb(7, 7, 7)" border={true} borderColor="#474646" borderSide="left">
          <CustomerBase />
        </Card>
      </div>
    </div>
  );
};

export default Dashboard;
